/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import axios from 'axios';
import ServicePath from "@/core/ServicePath"
import {
    MainRequest
} from "@/core/request";

export default class ClinicalEventRequest extends MainRequest{

    static addClinicalEvent(data, token) {
        return this.postSEC(ServicePath.CLINICAL_EVENT_ADD, data)
    }

    static listAllClinicalEvent(token) {
        return this.getSEC(ServicePath.CLINICAL_EVENT_LIST_ALL)
    }

    static updateClinicalEvent(data, token) {
        return this.postSEC(ServicePath.CLINICAL_EVENT_UPDATE, data)
    }

    static deleteClinicalEvent(data, token) {
        return this.postSEC(ServicePath.CLINICAL_EVENT_DELETE, data)
    }

    static listAllClinicalEventById(data, token) {
        return this.postSEC(ServicePath.CLINICAL_EVENT_LIST_BY_ID, data)
    }    
    
    static listClinicalEventByPatient(data, token) {
        return this.postSEC(ServicePath.CLINICAL_EVENT_LIST_BY_PATIENT, data)
    }
}